import { create } from 'zustand'

export interface SearchStore {
    searchValue: string

    setSearchValue: (value: string) => void
}

export const useSearchStore = create<SearchStore>()((set) => ({
    searchValue: '',

    setSearchValue: (value: string) => set({ searchValue: value }),
}))
